import { observer } from "mobx-react-lite";
import { useCallback } from "react";

import { useUnifiedRegistry } from "../unified-registry-context";

import { DateRangeFilter } from "@/components/ui/FilterBar";

const DateFilter: React.FC = () => {
  const registry = useUnifiedRegistry();

  const handleChange = useCallback(
    (range: { start?: string; end?: string } | null) => {
      if (!range || !range.start) {
        registry.setDateRange();
        return;
      }

      registry.setDateRange({ from: new Date(range.start) });
    },
    [registry],
  );

  const value = registry.dateRange?.from
    ? { start: registry.dateRange.from.toISOString(), end: new Date().toISOString() }
    : null;

  return <DateRangeFilter value={value} onChange={handleChange} placeholder="Date Created" />;
};

export default observer(DateFilter);
